import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useRemoteFilter } from './useRemoteFilter';

const remoteOptions = [
  { label: 'Any', value: 'any' },
  { label: 'Yes', value: 'remote' },
];

export const RemoteFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit } = useRemoteFilter({
    setFilters,
  });

  const selected = remoteOptions.find((i) => i.value.toString() === value?.toString()) ?? remoteOptions[0];

  return (
    <Formik
      initialValues={{ remote: selected || '' }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="remote"
          label="Remote position"
          placeholder="Remote position"
          size="small"
          component={FormSelect}
          options={remoteOptions}
          anchorToBody
          selectedOption={selected}
        />
      </Form>
    </Formik>
  );
};

RemoteFilter.propTypes = {
  value: PropTypes.string,
  setFilters: PropTypes.func.isRequired,
};

RemoteFilter.defaultProps = {
  value: '',
};
